import React from "react";

const MyComponent = () => {
  const handleOn = async () => {
    try {
      const payload = {
        devEUI: "6af03b46f5628502",
        command: "on"
      };

      const response = await fetch("https://biserna.maticnaknjiga.com:3001/api/poruka", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    devEUI: "6af03b46f5628502",
    command: "on"
  })
});

      if (!response.ok) {
        throw new Error("Gre�ka u HTTP zahtevu");
      }

      const data = await response.json();
      console.log("Odgovor sa servera:", data);
    } catch (error) {
      console.error("Gre�ka pri slanju poruke:", error);
    }
  };
  
    const handleOff = async () => {
    try {
      const payload = {
        devEUI: "6af03b46f5628502",
        command: "off"
      };

      const response = await fetch("https://biserna.maticnaknjiga.com:3001/api/poruka", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    devEUI: "6af03b46f5628502",
    command: "off"
  })
});

      if (!response.ok) {
        throw new Error("Gre�ka u HTTP zahtevu");
      }

      const data = await response.json();
      console.log("Odgovor sa servera:", data);
    } catch (error) {
      console.error("Gre�ka pri slanju poruke:", error);
    }
  };

  return (
  <div>
    <button onClick={handleOn}>
      Switch ON
    </button>
	
	<button onClick={handleOff}>
      Switch OFF
    </button>
  </div>
  );
};

export default MyComponent;
